import { Text } from '@mantine/core'

const SectionHeader = ({ children }: { children: React.ReactNode }) => (
  <Text
    size="xs"
    fw={400}
    className="uppercase text-doubleNickel-gray-500"
  >
    {children}
  </Text>
)

export default SectionHeader
